import { useQueryClient } from '@tanstack/react-query';
const PREFIX = ['platform', 'integrationTool'];
export function createIntegrationToolRepository(config) {
    const { repository, client } = config;
    function getFindQueryKey(props) {
        return [...PREFIX, 'find', props];
    }
    function getRetrieveQueryKey(integrationToolId) {
        return [...PREFIX, 'retrieve', integrationToolId];
    }
    return {
        useFind(context, props, options) {
            const queryClient = useQueryClient();
            const query = repository.useQuery({
                ...options,
                queryKey: getFindQueryKey(props),
                async queryFn() {
                    const response = await client.user.integrationToolList(props);
                    return response.data.data;
                },
                onSuccess(data) {
                    for (const item of data) {
                        const queryKey = getRetrieveQueryKey(item.id);
                        queryClient.setQueryData(queryKey, item);
                    }
                },
            });
            return query;
        },
        useRetrieve(context, integrationToolId, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getRetrieveQueryKey(integrationToolId),
                async queryFn() {
                    const response = await client.user.integrationToolRetrieve({
                        integrationToolId,
                    });
                    return response.data;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=integrationToolRepository.js.map